/**
 * 
 * @param {Number} index 
 * @param {HTML} element 
 */
function ProductImages( index, element, options ) {
    this.$element = $( element );

    this.selectors = {
        wrapper: ".carousel",
        slider: ".carousel__slides",
        items: ".carousel__item"
    }

    this.options = Object.assign( {}, {
      cellSelector: this.selectors.items,
      selectedAttraction: 0.2,
      friction: 0.8,
      groupCells: true,
      lazyLoad: true,
      wrapAround: false,
      prevNextButtons: true,
      contain: true,
      cellAlign: "center",
      pageDots: false,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
      }
    }, options );

    this.init();
}

ProductImages.prototype = Object.assign( {}, ProductImages.prototype, {
    init: function() {
        this.$slider = this.$element.find( this.selectors.slider );

        this.initializeSlider();
    },
    initializeSlider: function() {
        if( !this.$slider.hasClass( "flickity-enabled" ) ) {
            this.$slider.flickity( this.options );
        }
    }
} );